import { Component, Input } from '@angular/core';
import { EChartsOption } from 'echarts';

@Component({
  selector: 'app-risk-pie-graph',
  templateUrl: './risk-pie-graph.component.html',
  styleUrl: './risk-pie-graph.component.scss',
})
export class RiskPieGraphComponent {
  @Input() set chartHeight(val: any) {
    if (val) this.height = val + 'px';
  }
  @Input() set chartData(val: any) {
    if (val) {
      this.chartDataDetails = val;
      this.setGraphData(val);
    }
  }
  height = '';
  chartDataDetails: any;
  chartOption: EChartsOption;
  setGraphData(val: any) {
    this.chartOption = {
      tooltip: {
        trigger: 'item',
      },
      legend: {
        top: '5%',
        left: 'center',
      },
      series: [
        {
          name: 'Critical Incidents',
          type: 'pie',
          radius: ['40%', '70%'],
          avoidLabelOverlap: false,
          padAngle: 5,
          itemStyle: {
            borderRadius: 10,
          },
          label: {
            show: false,
            position: 'center',
          },
          emphasis: {
            label: {
              show: true,
              fontSize: 40,
              fontWeight: 'bold',
            },
          },
          labelLine: {
            show: false,
          },
          data: [
            { value: val.highScore, name: 'High' },
            { value: val.mediumScore, name: 'Medium' },
            { value: val.lowScore, name: 'Low' },
          ],
        },
      ],
    };
  }
}
